/* eslint-disable import/no-cycle */
/* eslint-disable no-lonely-if */
import { useMemo } from 'react';
import { isFieldSchema, isSectionSchema } from '../utils';
import { FormFieldT, FormItemT, FormSectionT } from '../types';
import { useStoreState } from '../../../../models/hooks';

function findParentSection(items: FormItemT[], targetFieldId: string, isFollowUp = false): FormSectionT | null {
  // eslint-disable-next-line
  for (const item of items) {
    if (isSectionSchema(item)) {
      const isDirectChild = item.fields.some((field) => field.id === targetFieldId);
      if (isDirectChild) {
        return item;
      }
      const foundInChildren = findParentSection(item.fields, targetFieldId, isFollowUp);
      if (foundInChildren) {
        return foundInChildren;
      }
    } else {
      if (isFollowUp && isFieldSchema(item) && item.followUpQuestionList) {
        const foundInChildren = findParentSection(item.followUpQuestionList, targetFieldId, isFollowUp);
        if (foundInChildren) {
          return foundInChildren;
        }
      }
    }
  }
  return null;
}

export function findSiblings(
  items: FormItemT[],
  targetFieldId: string,
  withCurrentField = false,
  isFollowUp = false,
): FormFieldT[] {
  const parentSection = findParentSection(items, targetFieldId, isFollowUp);

  if (!parentSection || !Array.isArray(parentSection.fields)) {
    return [];
  }
  const fields = parentSection.fields as FormFieldT[];
  if (withCurrentField) {
    return fields;
  }
  return fields.filter((item): item is FormFieldT => isFieldSchema(item) && item.id !== targetFieldId);
}

export function useSiblingFields(currentFieldId?: string, withCurrentField = false): FormFieldT[] {
  const formSchema = useStoreState((state) => state.formBuilder.formSchema);

  const siblingFields = useMemo(
    (): FormFieldT[] => {
      if (!currentFieldId || !formSchema || formSchema.length === 0) {
        return [];
      }

      return findSiblings(formSchema, currentFieldId, withCurrentField);
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [currentFieldId, formSchema],
  );

  return siblingFields;
}
